<template>
<div class="chapter">
<div class="inner_page">
<h1 class="pn">PART ONE</h1>
<p class="corn">•    •    •    •    •</p>
<h1 class="pt">Birth of a Bootlegger</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f008.vue?b8ff453e